export const padNum = (num, length = 4) => {
  let ret = String(num);
  while (ret.length < length) {
    ret = "0" + ret;
  }

  return ret;
};
